// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import {
  OperatorApi,
  ServerConfiguration,
  createConfiguration,
} from '@digitalasset/utility-operator-api-ts-client';
import React, { useMemo } from 'react';
import { UtilityOperatorApiContext } from './UtilityOperatorApiContext';

interface UtilityOperatorApiProps {
  utilityOperatorUrl: string;
}

export const UtilityOperatorProxyApiProvider = ({
  utilityOperatorUrl,
  children,
}: React.PropsWithChildren<UtilityOperatorApiProps>) => {
  const client: OperatorApi | undefined = useMemo(() => {
    const configuration = createConfiguration({
      baseServer: new ServerConfiguration(utilityOperatorUrl, {}),
    });

    return new OperatorApi(configuration);
  }, [utilityOperatorUrl]);

  return (
    <UtilityOperatorApiContext.Provider value={client}>
      {children}
    </UtilityOperatorApiContext.Provider>
  );
};
